module.exports = __webpack_public_path__ + "static/media/(V)_MG_6327_-_Joias_Contenporaneas.6b440b0e.jpg";